import { useContext } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { AppContext } from "../../../context";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
} from "reactstrap";
import InputField from "../../../components/layout/InputField";
import { customSelectStyleNew } from "../../../components/styled/customSelect";
import { IdealWorkType } from "../../../utils/constant";
import { moneyFieldHandler } from "../../../utils/helper";

const IdealEmployment = ({
  register,
  errors,
  control,
  getValues,
  setValue,
  watch,
}) => {
  // const [val, setVal] = useState("hourly");
  const { theme } = useContext(AppContext);

  return (
    <div>
      <h5>Ideal Employment</h5>

      <div className="user-basic-form">
        <InputField
          inputtype="text"
          isRequired={false}
          label="Ideal Job Title"
          inputid="idealJobTitle"
          placeholder="Job Title"
          {...register('idealJobTitle', {
            required: {
              value: false,
              message: "Job Title is required!",
            },
          })}
          errMsg={errors?.idealJobTitle?.message as any}
        />
      </div>

      <FormGroup>
        <Label>Work Type</Label>
        <Controller
          name="idealWorkType"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              options={IdealWorkType}
              placeholder="Work Type"
              styles={{ ...customSelectStyleNew(theme) }}
            />
          )}
        />
      </FormGroup>

      <div>
        <Label>Salary Rate</Label>
        <div className="relocate-allowed">
          <FormGroup check className="p-0">
            <Label className="radio-container" style={{ fontSize: "inherit" }}>
              Annually
              <Controller
                name="salaryType"
                control={control}
                defaultValue="" // or "false" depending on your logic
                render={({ field }) => (
                  <Input
                    type="radio"
                    value="ANNUAL"
                    checked={field.value === "ANNUAL"}
                    onChange={(e) => field.onChange(e.target.value)}
                    onBlur={field.onBlur}
                    innerRef={field.ref}
                  />
                )}
              />
              <span className="checkmark"></span>
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label className="radio-container" style={{ fontSize: "inherit" }}>
              Hourly
              <Controller
                name="salaryType"
                control={control}
                defaultValue="" // or "false" depending on your logic
                render={({ field }) => (
                  <Input
                    type="radio"
                    value="HOURLY"
                    checked={field.value === "HOURLY"}
                    onChange={(e) => field.onChange(e.target.value)}
                    onBlur={field.onBlur}
                    innerRef={field.ref}
                  />
                )}
              />
              <span className="checkmark"></span>
            </Label>
          </FormGroup>
        </div>
      </div>

      <div className="dollar-addon-btn d-flex justify-content-between">
        <FormGroup className="mr- 2 w-50">
          <Label>Salary Min</Label>

          <InputGroup>
            <InputGroupAddon addonType="prepend">$</InputGroupAddon>
            <Input
              placeholder="Amount"
              value={
                watch
                  ? (() => {
                      const v = watch("salaryMin");
                      if (v === "" || v == null) return "";
                      if (typeof v === "number" && Number.isNaN(v)) return "";
                      return String(v);
                    })()
                  : undefined
              }
              {...register("salaryMin")}
              onChange={(e) => {
                const raw = e?.target?.value ?? "";
                if (raw === "") {
                  setValue("salaryMin", "", { shouldValidate: true });
                } else {
                  moneyFieldHandler(raw, setValue, "salaryMin");
                  register("salaryMin").onChange(e);
                }
              }}
            />
          </InputGroup>
          <small className="text-danger">{errors?.salaryMin?.message as any}</small>
        </FormGroup>

        <FormGroup className="ml-2 w-50">
          <Label>Salary Max</Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">$</InputGroupAddon>
            <Input
              placeholder="Amount"
              value={
                watch
                  ? (() => {
                      const v = watch("salaryMax");
                      if (v === "" || v == null) return "";
                      if (typeof v === "number" && Number.isNaN(v)) return "";
                      return String(v);
                    })()
                  : undefined
              }
              {...register("salaryMax")}
              onChange={(e) => {
                const raw = e?.target?.value ?? "";
                if (raw === "") {
                  setValue("salaryMax", "", { shouldValidate: true });
                } else {
                  moneyFieldHandler(raw, setValue, "salaryMax");
                  register("salaryMax").onChange(e);
                }
              }}
            />
          </InputGroup>
          <small className="text-danger">{errors?.salaryMax?.message as any}</small>
        </FormGroup>
      </div>
    </div>
  );
};

export default IdealEmployment;
